<section class="job-list-section py-5 background">
    <div class="container">

        <div class="search-shell d-flex flex-column flex-lg-row overflow-hidden" [class.mb-0]="isLoggedIn"
            [class.mb-4]="!isLoggedIn">
            <div class="search-part d-flex align-items-center px-3 py-2 flex-grow-1">
                <i class="bi bi-search me-2 search-icon"></i>
                <input type="text" [formControl]="freeTextControl"
                    class="form-control border-0 shadow-none p-0 search-input"
                    placeholder="What kind of job you'd like?" />
            </div>

            <div class="search-part search-part-location d-flex align-items-center px-3 py-2">
                <i class="bi bi-geo-alt me-2 search-icon"></i>
                <input type="text" [formControl]="locationControl"
                    class="form-control border-0 shadow-none p-0 search-input" placeholder="Where?" />
            </div>

            <button type="button" class="btn search-btn px-4 px-lg-5 py-2 rounded-0" (click)="search()">
                Search
            </button>
        </div>

        <div class="card p-3 search-shell">
            <div class="row g-2">
                <div class="col-12 col-md-3">
                    <label class="form-label">Work experience</label>
                    <select class="form-select" [(ngModel)]="filterExperience">
                        <option value="">All</option>
                        <option *ngFor="let option of jobExperience" [value]="option.value">{{ option.label }}</option>
                    </select>
                </div>

                <div class="col-12 col-md-3">
                    <label class="form-label">Type of employment</label>
                    <select class="form-select" [(ngModel)]="filterType">
                        <option value="">All</option>
                        <option *ngFor="let option of jobTypeOptions" [value]="option.value">{{ option.label }}</option>
                    </select>
                </div>

                <div class="col-12 col-md-3">
                    <label class="form-label">Tags</label>
                    <input class="form-control" type="text" [(ngModel)]="filterTags" placeholder="e.g. C#, Angular" />
                </div>

                <div class="col-12 col-md-3">
                    <label class="form-label">Sort</label>
                    <select class="form-select" [(ngModel)]="sort">
                        <option value="">Most relevant</option>
                        <option value="title">Job name</option>
                        <option value="tags">Tags</option>
                        <option value="type">Employment type</option>
                        <option value="date">Date</option>
                    </select>
                </div>
            </div>

            <div class="d-flex gap-2 mt-3">
                <button class="btn search-btn" type="button" (click)="applyFilters()">Apply</button>
                <button class="btn search-btn-secondary" type="button" (click)="clearFilters()">Clear</button>
            </div>
        </div>

        @if (filteredJobs$ | async; as jobs) {
        @if (jobs.length > 0) {

        <div class="row text-start pb-5 mt-4">
            <!-- Left Column: Master List of Jobs -->
            <div class="col-lg-7 col-md-6 mb-4 d-flex flex-column gap-3">
                @for (job of jobs; track job.id) {
                <div class="card border-0 radius" [class.border-0]="selectedJob?.id !== job.id"
                    [class.border]="selectedJob?.id === job.id" [class.border-highlight]="selectedJob?.id === job.id"
                    [class.shadow-sm]="selectedJob?.id === job.id" (click)="selectJob(job)">
                    <div class="card-body p-4">

                        <h4 class="fw-bold color mb-3">{{job.title}}</h4>
                        <div class="d-flex gap-2 mb-3">
                            @for(tag of job.tags; track $index){
                            <span class="badge-primary text-dark">
                                <i class="bi bi-briefcase text-danger"></i> {{tag}}
                            </span>
                            }
                        </div>

                        <div class="text-secondary small d-flex flex-column gap-1">
                            <span><i class="bi bi-geo-alt text-danger"></i> {{job.location}}</span>
                            <span><i class="bi bi-clock text-danger"></i> {{ getTimeAgo(job.createdAt) }}</span>
                        </div>
                    </div>
                </div>
                }
            </div>

            <div class="col-lg-5 col-md-6">
                @if (selectedJob) {
                <div class="card border-0 shadow-sm" style="border-radius: 16px; position: sticky; top: 20px;">
                    <div class="card-body p-4">

                        <div class="d-flex justify-content-between align-items-start mb-2">
                            <h2 class="fw-bold color mb-0">{{selectedJob.title}}</h2>

                            <a class="btn btn-link text-dark p-0" title="Open Full View"
                                [routerLink]="['/full-job-view', selectedJob.id]">
                                <i class="bi bi-arrow-right fs-4"></i>
                            </a>
                        </div>

                        <div class="small">
                            <p class="weight mb-2">{{selectedJob.shortDescription}}</p>
                        </div>

                        <hr class="divider">
                        <h6 class="fw-bold mb-3">Job characteristics</h6>
                        <div class="d-flex gap-2 mb-4">
                            <span class="badge-primary text-dark">
                                <i class="bi bi-briefcase text-danger"></i> {{selectedJob.employmentType}}
                            </span>
                            @for(tag of selectedJob.tags; track $index){
                            <span class="badge-primary text-dark">
                                <i class="bi bi-briefcase text-danger"></i> {{tag}}
                            </span>
                            }
                        </div>

                        <hr class="divider">
                        <h6 class="fw-bold mb-2">Office location</h6>
                        <p class="small text-muted mb-0">{{selectedJob.location}}</p>

                        <hr class="divider">
                        <div class="d-flex justify-content-between align-items-start mt-4">
                            <button class="btn apply-btn text-center" [routerLink]="['/job', selectedJob.id]">
                                Submit your application
                            </button>
                        </div>


                    </div>
                </div>
                } @else {
                <div class="text-center p-5 text-muted h-100 d-flex flex-column justify-content-center align-items-center bg-white"
                    style="border-radius: 16px;">
                    <h5>Select a job to see details</h5>
                </div>
                }
            </div>
        </div> <!-- End of Master/Detail Row -->

        } @else {
        <div class="text-center py-5">
            <i class="bi bi-search display-1 text-muted opacity-50 mb-3 d-block"></i>
            <h3 class="text-muted">No jobs found matching your criteria</h3>
        </div>
        }
        }
    </div>
</section>